import SortingIcon from "../../table-common/SortingIcon";
import PropTypes from "prop-types";
import React from "react";
import {getUnitConsistSortingFunction} from "../../table-common/table-sorting";
import {getHighlightedText} from "../../table-common/table-search";

const TableHeader = ({sortingBy, sortReversed, changeSort}) => {
  return (
    <thead>
    <tr>
      <th onClick={() => changeSort('consist', false)}>
        Consist <SortingIcon
        visible={sortingBy === 'consist'} reversed={sortReversed}/>
      </th>
      <th onClick={() => changeSort('seen_date', false)}>
        First Seen <SortingIcon
        visible={sortingBy === 'seen_date'} reversed={sortReversed}/>
      </th>
    </tr>
    </thead>
  )
}

TableHeader.propTypes = {
  sortingBy: PropTypes.string,
  sortReversed: PropTypes.bool,
  changeSort: PropTypes.func
}

const TableRow = ({unit, element, searchBy}) => {
  // Access to Angular filters from ekeFilters.js
  const injector = angular.element(".ng-scope").injector();
  const timestampFormatter = injector.get('formatTimestampDateFilter');
  return (
    <tr>
      <td>{getHighlightedText(element.consist, unit)}</td>
      <td>{timestampFormatter(element.seenDate)}</td>
    </tr>
  )
};
TableRow.propTypes = {
  element: PropTypes.object,
  uniqueConditions: PropTypes.array,
  searchBy: PropTypes.string
}

const UnitConsistTable = ({unit, history, loading, searchBy, sortingBy, sortReversed, changeSort}) => {
  let tableContent = (<tr>
    <td>No {searchBy ? "matching" : ""} data</td>
  </tr>);
  if (loading) {
    tableContent = (<tr>
      <td>Loading..</td>
    </tr>);
  }
  if (history.length) {
    tableContent = history
      .sort(getUnitConsistSortingFunction(sortingBy, sortReversed))
      .map(seenConsist =>
        (<TableRow
            key={JSON.stringify(seenConsist)}
            unit={unit}
            element={seenConsist}
            searchBy={searchBy}/>
        ));
  }

  return (
    <div className="unit-consist-table">
      <table aria-label="Consists that the unit has been a part of">
        <TableHeader
          sortingBy={sortingBy}
          sortReversed={sortReversed}
          changeSort={changeSort}
          searchBy={searchBy}
        />
        <tbody>{tableContent}</tbody>
      </table>
    </div>
  );
};

export default UnitConsistTable;
